import { Artwork, MomentControls, type PartyConnection } from '@karozik/ui';

/** Kiosk animator mode (PIN): the organiser's shortcuts, without moderation. */
export function AnimatorPanel({ conn, onExit }: { conn: PartyConnection; onExit(): void }) {
  const np = conn.state?.nowPlaying;
  return (
    <main className="mx-auto max-w-3xl px-8 pt-8 pb-12">
      <header className="mb-6 flex items-center gap-4">
        <div className="flex-1">
          <div className="text-sm font-semibold tracking-widest text-pink uppercase">Mode animateur</div>
          {np && (
            <div className="mt-2 flex items-center gap-3">
              <Artwork track={np.track} className="h-12 w-12" rounded="rounded-xl" />
              <div>
                <div className="font-semibold">{np.track.title}</div>
                <div className="text-sm text-ink-dim">{np.track.artist}</div>
              </div>
            </div>
          )}
        </div>
        <button onClick={onExit} className="rounded-2xl bg-surface-2 px-6 py-4 text-lg font-semibold">
          🔒 Quitter
        </button>
      </header>
      {conn.connected ? <MomentControls conn={conn} /> : <p className="text-ink-dim">Connexion…</p>}
    </main>
  );
}
